import * as MeetingsActions from './meetings.actions';

import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {createReducer, on} from '@ngrx/store';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {StoredComponentHelperService} from '@common/helpers/stored-component.helper.service';
import {Meeting} from '@communication/_common/models/meeting.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const meetingsListFeatureKey = 'list';

export function sortByCreationTime(a: Meeting, b: Meeting) {
    if (a.startDate! < b.startDate!) {
        return 1;
    } else if (a.startDate! > b.startDate!) {
        return -1;
    } else {
        return 0;
    }
}

export const adapter: EntityAdapter<Meeting> = createEntityAdapter<Meeting>({
    sortComparer: sortByCreationTime
});

export interface MeetingsListState extends EntityState<Meeting> {
    loading?: DahLoadingType;
    itemsLoading?: string[];
    pagination?: DahPaginationModel;
    filter?: any;
}

export const initialState: MeetingsListState = adapter.getInitialState({
    loading: undefined,
    itemsLoading: [],
    pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 0,
        size: 50,
        totalElements: 0
    },
    filter: {}
});

export const meetingsListReducer = createReducer(
    initialState,

    on(MeetingsActions.LoadMeetings, (state, action) => ({
        ...state,
        loading: action.payload.loading
    })),

    on(MeetingsActions.LoadMeetingsSuccess, (state, action) => {
        return (
            adapter.setAll(action.payload.items, {
                ...state,
                loading: undefined,
                pagination: {...action.payload.pagination}
            })
        );
    }),

    on(MeetingsActions.LoadMeetingsFailure, (state) => ({...state, loading: undefined})),

    on(MeetingsActions.UpdateMeeting, (state, action) => {
        return (
            adapter.updateOne({id: action.payload.id!, changes: action.payload}, {
                ...state
            })
        );
    }),

    on(MeetingsActions.UpsertMeeting, (state, action) => {
        return (
            adapter.setOne((action.payload), {
                ...state
            })
        );
    }),

    on(MeetingsActions.SetMeetingItemLoading, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state?.itemsLoading, action.payload.id, action.payload.isStart)
    })),

    on(MeetingsActions.DeleteMeeting, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state?.itemsLoading, action.payload, true)
    })),

    on(MeetingsActions.DeleteSuccess, (state, action) => {
        return (
            adapter.removeOne(action.payload, {
                ...state,
                itemsLoading: StoredComponentHelperService.updateItemLoading(state?.itemsLoading, action.payload, false)
            })
        );
    }),

    on(MeetingsActions.DeleteMeetingFailure, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state?.itemsLoading, action.payload, false)
    })),

    on(MeetingsActions.SetInitialState, SetAllInitialStates, () => ({...initialState})),
);

export const {selectAll: selectAllList} = adapter.getSelectors();
